"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _KpnBanner = require("./KpnBanner");
Object.keys(_KpnBanner).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _KpnBanner[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _KpnBanner[key];
    }
  });
});